import { LocalStorageService } from '../../../services/local-storage/local-storage.service';

/** Kundenportal - Viehhändler - anzeigen */
export const PERMISSION_HAENDLER_ANZEIGEN = 9131;

/** Kundenportal - Viehhändler - anlegen */
export const PERMISSION_HAENDLER_ANLEGEN = 9132;

/** Kundenportal - Viehhändler - editieren */
export const PERMISSION_HAENDLER_BEARBEITEN = 9133;

export function canViewHaendler(localStorageService: LocalStorageService): boolean {
    return localStorageService.hasPermission(PERMISSION_HAENDLER_ANZEIGEN);
}

export function canEditHaendler(localStorageService: LocalStorageService): boolean {
    return (
        localStorageService.hasPermission(PERMISSION_HAENDLER_ANLEGEN) ||
        localStorageService.hasPermission(PERMISSION_HAENDLER_BEARBEITEN)
    );
}
